import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { CartFunnelTextItemBlockConfig } from '@front-platform/content-builder';
import { cartFunnelTextItemBlockResolveConfig } from '@front-platform/content-builder';
import { take } from 'rxjs/operators';
import { Component, OnInit, input } from '@angular/core';

import { CartFunnelStoreSelector } from '@common/selectors/cart-funnel.selector';
import { CartFunnelStoreDispatcher } from '@common/dispatchers/cart-funnel.dispatcher';
export interface CartFunnelTextItemBlockRuntimeConfig {
  'block_id'?: string;
  'form_id'?: string;
}

export type CartFunnelTextItemBlockConfigInput = Partial<
  Omit<CartFunnelTextItemBlockConfig, keyof CartFunnelTextItemBlockRuntimeConfig> &
    CartFunnelTextItemBlockRuntimeConfig
>;
export type CartFunnelTextItemBlockResolvedConfig = Omit<
  CartFunnelTextItemBlockConfig,
  keyof CartFunnelTextItemBlockRuntimeConfig
> &
  Partial<CartFunnelTextItemBlockRuntimeConfig>;
export interface CartFunnelTextItemBlockContract extends ConfigComponentContract<
  CartFunnelTextItemBlockConfigInput,
  CartFunnelTextItemBlockResolvedConfig
> {}

@Component({
  selector: 'app-cart-funnel-text-item-block',
  templateUrl: './cart-funnel-text-item-block.component.html',
  standalone: false,
})
export class CartFunnelTextItemBlockComponent implements OnInit, CartFunnelTextItemBlockContract {
  readonly config = input<CartFunnelTextItemBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    CartFunnelTextItemBlockConfig,
    CartFunnelTextItemBlockRuntimeConfig
  >(cartFunnelTextItemBlockResolveConfig, () => ({ config: this.config() }));
  get title(): string {
    return this.resolvedConfig()['title'] as unknown as string;
  }
  get placeholder(): string {
    return this.resolvedConfig()['placeholder'] as unknown as string;
  }
  get inputCharset(): 'text' | 'numeric' {
    return this.resolvedConfig()['input_charset'] === 'numeric' ? 'numeric' : 'text';
  }
  get required(): boolean {
    return this.resolvedConfig()['required'] as unknown as boolean;
  }
  get customTitle(): string | undefined {
    return this.resolvedConfig()['custom_title'] as unknown as string | undefined;
  }
  get displayCustomTitleInComment(): boolean {
    return this.resolvedConfig()['display_custom_title_in_comment'] as unknown as boolean;
  }
  get blockId(): string {
    return this.resolvedConfig()['block_id'] as unknown as string;
  }
  get formId(): string {
    return this.resolvedConfig()['form_id'] as unknown as string;
  }

  value = '';

  constructor(
    private cartFunnelSelector: CartFunnelStoreSelector,
    private cartFunnelDispatcher: CartFunnelStoreDispatcher,
  ) {}

  ngOnInit(): void {
    this.cartFunnelDispatcher.addValue({
      id: this.blockId,
      title: this.title,
      displayTitle: true,
      formId: this.formId,
      required: this.required,
      customTitle: this.customTitle,
      displayCustomTitleInComment: this.displayCustomTitleInComment,
    });

    this.cartFunnelSelector
      .selectValue(this.blockId)
      .pipe(take(1))
      .subscribe(form => {
        this.value = form?.value?.toString() ?? '';
      });
  }

  onValueChange(_value: string | boolean): void {
    const next =
      this.inputCharset === 'numeric' && typeof _value === 'string'
        ? _value.replace(/\D/g, '')
        : _value;
    if (this.inputCharset === 'numeric' && typeof next === 'string') {
      this.value = next;
    }
    this.cartFunnelDispatcher.updateValue({
      id: this.blockId,
      changes: {
        value: next,
      },
    });
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(CartFunnelTextItemBlockComponent, {
  'keyAliases': {},
});
